import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("awzdE"), parcelRequire.load("kWrGa"), parcelRequire.load("Q9f8u"), parcelRequire.load("7KiPh"), parcelRequire.load("bpBCQ"), parcelRequire.load("373ut"), parcelRequire.load("b08yR"), parcelRequire.load("44zBO"), parcelRequire.load("blC0m")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("awzdE")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("kWrGa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("Q9f8u")} />
  <link rel="modulepreload" href={parcelRequire.resolve("7KiPh")} />
  <link rel="modulepreload" href={parcelRequire.resolve("bpBCQ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("373ut")} />
  <link rel="modulepreload" href={parcelRequire.resolve("b08yR")} />
  <link rel="modulepreload" href={parcelRequire.resolve("44zBO")} />
  <link rel="modulepreload" href={parcelRequire.resolve("blC0m")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
